// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tool-progress {
  container-type: inline-size;
  container-name: tool-progress;
}
.tool-progress-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
}
.tool-progress tbody {
  display: block;
}
.tool-progress td {
  padding: 0;
}
.tool-progress thead {
  display: none;
}
.tool-progress-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
}
@container tool-progress (min-width: 600px) {
  .tool-progress-grid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr) minmax(0, 1.4fr);
  }
  .tool-progress thead {
    display: block;
  }
  .tool-progress-label {
    display: none;
  }
}

.tool-progress [data-expanded-row],
.tool-progress [data-expanded-row] > td {
  display: block;
}
.tool-progress [data-expanded-row] > td {
  padding: 0.5rem 1rem 0.75rem;
}
.tool-progress thead tr {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr) minmax(0, 1.4fr);
  gap: 0.75rem;
  padding: 0.5rem 1rem;
}
.tool-progress th {
  height: auto;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatView/ToolProgress.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE;IACE,wEAAwE;EAC1E;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,wEAAwE;EACxE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,UAAU;AACZ","sourcesContent":[".tool-progress {\n  container-type: inline-size;\n  container-name: tool-progress;\n}\n.tool-progress-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n}\n.tool-progress tbody {\n  display: block;\n}\n.tool-progress td {\n  padding: 0;\n}\n.tool-progress thead {\n  display: none;\n}\n.tool-progress-label {\n  display: block;\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-bottom: 0.25rem;\n}\n@container tool-progress (min-width: 600px) {\n  .tool-progress-grid {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr) minmax(0, 1.4fr);\n  }\n  .tool-progress thead {\n    display: block;\n  }\n  .tool-progress-label {\n    display: none;\n  }\n}\n\n.tool-progress [data-expanded-row],\n.tool-progress [data-expanded-row] > td {\n  display: block;\n}\n.tool-progress [data-expanded-row] > td {\n  padding: 0.5rem 1rem 0.75rem;\n}\n.tool-progress thead tr {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr) minmax(0, 1.4fr);\n  gap: 0.75rem;\n  padding: 0.5rem 1rem;\n}\n.tool-progress th {\n  height: auto;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
